class PnMKonfigurator {
  constructor(el) {
    this.root = el;
    this.max = parseInt(el.dataset.max) || 10;
    this.productId = el.dataset.productId || '';
    this.variantId = el.dataset.variantId || '';
    this.selections = {}; // { variantId: { title, quantity, price } }
    this.total = 0;
    this.init();
  }

  init() {
    this.root.querySelectorAll('.pnm-card').forEach(card => {
      card.addEventListener('click', (e) => this.onCardClick(e, card));
    });

    this.root.querySelectorAll('.pnm-qty-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const card = btn.closest('.pnm-card');
        const delta = btn.dataset.delta === '+' ? 1 : -1;
        this.changeQty(card, delta);
      });
    });

    const addBtn = this.root.querySelector('#pnm-add-to-cart');
    if (addBtn) {
      addBtn.addEventListener('click', () => this.handleAddToCart());
    }

        this.productData = null;
            fetch('/products/' + window.location.pathname.split('/products/').pop().split('?')[0] + '.js')
                  .then(r => r.json())
                        .then(d => { this.productData = d; this.updateUI(); });
    this.updateUI();
  }

  onCardClick(e, card) {
    if (e.target.closest('.pnm-qty-controls')) return;
    const vid = card.dataset.variantId;
    if (!vid) return;

    if (this.selections[vid]) {
      // Already selected - clicking again removes it
      this.selections[vid].quantity = 0;
      delete this.selections[vid];
    } else {
      if (this.total >= this.max) {
        this.shakeCounter();
        return;
      }
      this.selections[vid] = {
        title: card.dataset.title || '',
        quantity: 1,
        price: card.dataset.price || ''
      };
    }
    this.recalcTotal();
    this.updateCard(card);
    this.updateUI();
  }

  changeQty(card, delta) {
    const vid = card.dataset.variantId;
    if (!vid) return;

    if (!this.selections[vid]) {
      if (delta < 0) return;
      if (this.total >= this.max) { this.shakeCounter(); return; }
      this.selections[vid] = { title: card.dataset.title || '', quantity: 0, price: card.dataset.price || '' };
    }

    const newQty = this.selections[vid].quantity + delta;

    if (newQty <= 0) {
      delete this.selections[vid];
    } else {
      const wouldAdd = newQty - (this.selections[vid]?.quantity || 0);
      if (this.total + wouldAdd > this.max) {
        this.shakeCounter();
        return;
      }
      this.selections[vid].quantity = newQty;
    }

    this.recalcTotal();
    this.updateCard(card);
    this.updateUI();
  }

  recalcTotal() {
    this.total = Object.values(this.selections).reduce((s, v) => s + v.quantity, 0);
  }

  updateCard(card) {
    const vid = card.dataset.variantId;
    const sel = this.selections[vid];
    const qty = sel ? sel.quantity : 0;
    const qtyEl = card.querySelector('.pnm-qty-value');
    const minusBtn = card.querySelector('.pnm-qty-btn[data-delta="-"]');

    card.classList.toggle('pnm-selected', qty > 0);
    if (qtyEl) qtyEl.textContent = qty;
    if (minusBtn) minusBtn.disabled = qty <= 0;
  }

  updateUI() {
    // Update all cards (for plus btn disabled state)
    this.root.querySelectorAll('.pnm-card').forEach(card => {
      const vid = card.dataset.variantId;
      const sel = this.selections[vid];
      const qty = sel ? sel.quantity : 0;
      const plusBtn = card.querySelector('.pnm-qty-btn[data-delta="+"]');
      const minusBtn = card.querySelector('.pnm-qty-btn[data-delta="-"]');
      const qtyEl = card.querySelector('.pnm-qty-value');
      card.classList.toggle('pnm-selected', qty > 0);
      if (qtyEl) qtyEl.textContent = qty;
      if (plusBtn) plusBtn.disabled = this.total >= this.max;
      if (minusBtn) minusBtn.disabled = qty <= 0;
    });

    // Update counters
    const counters = this.root.querySelectorAll('.pnm-count');
    counters.forEach(c => { c.textContent = this.total; });
    const maxEls = this.root.querySelectorAll('.pnm-max');
    maxEls.forEach(m => { m.textContent = this.max; });

    // Progress bars
    const pct = Math.min((this.total / this.max) * 100, 100);
    this.root.querySelectorAll('.pnm-progress-bar').forEach(bar => {
      bar.style.width = pct + '%';
      bar.style.backgroundColor = this.total >= this.max ? '#22c55e' : '#f97316';
    });

    // Bottom bar label
    const label = this.root.querySelector('#pnm-bottom-label');
    if (label) {
      if (this.total === 0) label.textContent = 'Wähle deine Süßigkeiten';
      else if (this.total < this.max) label.textContent = `${this.total} von ${this.max} gewählt – noch ${this.max - this.total} übrig`;
      else label.textContent = `${this.max} von ${this.max} – Fertig!`;
    }

    // Add-to-cart button
    const addBtn = this.root.querySelector('#pnm-add-to-cart');
    if (addBtn) {
      addBtn.disabled = this.total === 0;
      addBtn.classList.toggle('pnm-btn-ready', this.total > 0);

          // === Preis-Block in Bottom-Bar ===
              let _pw = this.root.querySelector('.pnm-box-price-wrap');
                  if (!_pw) {
                        const _bi = this.root.querySelector('.pnm-bottom-inner');
                              const _btn = this.root.querySelector('#pnm-add-to-cart');
                                    if (_bi && _btn) {
                                            const _w = document.createElement('div');
                                                    _w.className = 'pnm-box-price-wrap';
                                                            _bi.insertBefore(_w, _btn);
                                                                    _pw = _w;
                                                                          }
                                                                              }
                                                                                  if (_pw && this.productData) {
                                                                                        const _v = this.productData.variants[0];
                                                                                              const _fmt = c => (c / 100).toFixed(2).replace('.', ',');
                                                                                                    const _pr = _fmt(_v.price);
                                                                                                          const _cp = _v.compare_at_price ? _fmt(_v.compare_at_price) : '';
                                                                                                                const _upm = _v.unit_price_measurement;
                                                                                                                      const _kg = _v.unit_price && _upm ? '(' + _fmt(_v.unit_price) + '\u00a0\u20ac / ' + _upm.reference_unit + ')' : '';
                                                                                                                            _pw.innerHTML = '<div class="pnm-box-price-block">'
                                                                                                                                    + '<span class="pnm-box-price">\u20ac' + _pr + '<\/span>'
                                                                                                                                            + (_cp ? '<span class="pnm-box-compare-price">\u20ac' + _cp + '<\/span>' : '')
                                                                                                                                                    + (_kg ? '<span class="pnm-box-per-kg">' + _kg + '<\/span>' : '')
                                                                                                                                                            + '<\/div>';
                                                                                                                                                                }
    }
  }

  shakeCounter() {
    const counters = this.root.querySelectorAll('.pnm-count');
    counters.forEach(c => {
      c.classList.remove('pnm-shake');
      void c.offsetWidth;
      c.classList.add('pnm-shake');
    });
  }

  async handleAddToCart() {
    if (this.total === 0) return;
    const addBtn = this.root.querySelector('#pnm-add-to-cart');
    if (!addBtn) return;

    // Build line item properties
    const properties = {};
    let idx = 1;
    Object.values(this.selections).forEach(sel => {
      for (let i = 0; i < sel.quantity; i++) {
        properties[`Süßigkeit ${idx}`] = sel.title;
        idx++;
      }
    });

    // Also store variant IDs for backend processing
    const selectionSummary = Object.entries(this.selections)
      .map(([vid, sel]) => `${sel.title} x${sel.quantity}`)
      .join(', ');
    properties['Zusammenstellung'] = selectionSummary;

    const payload = {
      id: parseInt(this.variantId),
      quantity: 1,
      properties: properties
    };

    // Loading state
    addBtn.disabled = true;
    const originalText = addBtn.textContent;
    addBtn.textContent = 'Wird hinzugefügt...';
    addBtn.classList.add('pnm-btn-loading');

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!resp.ok) {
        const err = await resp.json();
        throw new Error(err.description || 'Fehler beim Hinzufügen');
      }

      addBtn.textContent = '✓ Im Warenkorb!';
      addBtn.classList.remove('pnm-btn-loading');
      addBtn.classList.add('pnm-btn-success');

        this.showPostAddModal(addBtn);

    } catch (err) {
      addBtn.disabled = false;
      addBtn.textContent = 'Fehler – erneut versuchen';
      addBtn.classList.remove('pnm-btn-loading');
      addBtn.classList.add('pnm-btn-error');
      setTimeout(() => {
        addBtn.textContent = originalText;
        addBtn.classList.remove('pnm-btn-error');
        addBtn.classList.toggle('pnm-btn-ready', this.total > 0);
        addBtn.disabled = this.total === 0;
      }, 3000);
      console.error('[PnM] Add to cart error:', err);
    }
  }
  showPostAddModal(addBtn) {
    // Remove existing modal if any
    const existingModal = document.getElementById('pick-n-mix-modal');
    if (existingModal) existingModal.remove();

    // Create modal overlay
    const overlay = document.createElement('div');
    overlay.id = 'pick-n-mix-modal';
    overlay.style.cssText = `
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      font-family: inherit;
    `;

    // Create modal box
    const modal = document.createElement('div');
    modal.style.cssText = `
      background: #fff;
      border-radius: 12px;
      padding: 32px 28px;
      max-width: 420px;
      width: 90%;
      text-align: center;
      box-shadow: 0 8px 40px rgba(0,0,0,0.25);
    `;

    modal.innerHTML = `
      <div style="font-size: 2.5rem; margin-bottom: 12px;">🎉</div>
      <h2 style="margin: 0 0 10px; font-size: 1.4rem; font-weight: 700;">Tüte zum Warenkorb hinzugefügt!</h2>
      <p style="margin: 0 0 24px; color: #555; font-size: 0.95rem;">Was möchtest du als nächstes tun?</p>
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <button id="pnm-another-bag" style="
          background: #e8651a;
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 14px 20px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s;
        ">🎁 Noch eine Tüte erstellen</button>
        <button id="pnm-go-to-cart" style="
          background: #1a1a1a;
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 14px 20px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s;
        ">🛒 Zum Warenkorb</button>
      </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Re-enable the add button
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.textContent = addBtn.dataset.originalText || 'In den Warenkorb';
    }

    // Button: Create another bag
    document.getElementById('pnm-another-bag').addEventListener('click', () => {
      overlay.remove();
      // Reset configurator
      this.selections = {};
      this.total = 0;
      if (typeof this.updateUI === 'function') this.updateUI();
      // Scroll to top of configurator
      const configurator = document.querySelector('.pick-n-mix') || document.querySelector('[data-pick-n-mix]');
      if (configurator) {
        configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    // Button: Go to cart
    document.getElementById('pnm-go-to-cart').addEventListener('click', () => {
      window.location.href = '/cart';
    });

    // Click outside to close (same as "another bag")
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.remove();
        this.selections = {};
        this.total = 0;
        if (typeof this.updateUI === 'function') this.updateUI();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pnm-konfigurator').forEach(el => new PnMKonfigurator(el));
});
